import { Button } from '@mantine/core'
import { IconCompass } from '@tabler/icons-react'
import { useLocation, useNavigate } from 'react-router-dom'
import { EmptyState } from '@lighthouse/design'

/**
 * The catch-all route.
 *
 * Without it an unknown path — a stale /data-entry bookmark above all, since that
 * surface was removed — rendered the shell with an empty body, which reads as a
 * page that failed to load rather than one that does not exist (doc 04 §5.5).
 * `/hangfire` is opened with window.open and never routed, so this cannot
 * capture it.
 */
export function NotFoundPage() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  return (
    <EmptyState
      icon={<IconCompass size={28} stroke={1.5} />}
      title={`Nothing lives at ${pathname}`}
      message="This address is not an Observatory page. It may be a bookmark to a surface that has since been removed."
      action={
        <Button variant="light" size="xs" mt="sm" onClick={() => navigate('/dashboard')}>
          Go to the Overview
        </Button>
      }
    />
  )
}
